import { useMarketNavigate } from "Infrastructure/Routes/Hooks/useMarketNavigate";
import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { SettingsPaths } from "Settings/Routes/Routing";
import profilePhoto from "Shared/Assets/Images/Profiles/user-1.jpg";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import {
	Avatar,
	Box,
	IconButton,
	type Theme,
	Tooltip,
	useMediaQuery,
} from "@mui/material";
import { useAtom } from "jotai";
import { Link } from "react-router-dom";
import { signOut } from "supertokens-auth-react/recipe/session";
import { ThemeSwitch } from "./ThemeSwitch";

export const Profile = () => {
	const [themeConfiguration] = useAtom(themeAtom);
	const marketNavigate = useMarketNavigate();
	const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

	const shouldHideMenu = lgUp
		? themeConfiguration.isCollapse && !themeConfiguration.isSidebarHover
		: false;

	async function handleLogout() {
		try {
			await signOut();
			marketNavigate("/auth", "");
		} catch (error) {
			console.error("Error signing out:", error);
		}
	}

	if (shouldHideMenu) {
		return null;
	}

	return (
		<Box
			sx={{
				position: "sticky",
				bottom: 0,
				left: 0,
				right: 0,
				m: 2,
				p: 2,
				borderRadius: 1,
				bgcolor: (theme) => theme.palette.secondary.light,
				boxShadow: (theme) => theme.shadows[1],
				zIndex: (theme) => theme.zIndex.appBar - 1,
			}}
		>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="space-between"
				gap={1}
			>
				<Tooltip title="Logout" placement="top">
					<IconButton
						color="error"
						size="small"
						aria-label="logout"
						onClick={handleLogout}
					>
						<PowerSettingsNewIcon fontSize="medium" />
					</IconButton>
				</Tooltip>

				<Link to={SettingsPaths.UserDetail.path}>
					<Avatar alt="profile photo" src={profilePhoto} />
				</Link>

				<ThemeSwitch />
			</Box>
		</Box>
	);
};
